import * as React from 'react';

import {CancelButton} from '../button/cancel-button/cancel-button';
import {CheckmarkButton} from '../button/checkmark-button/checkmark-button';

import styles from './inline-form-wrapper.module.css';

type Props = {
    shouldShowControls: boolean;
    onCancel: () => any;
    onSubmit: () => any;
    canSubmit: boolean;
    children?: React.ReactNode;
};

/**
 * Component responsible for wrapping a textfield with some floating
 * submit / clear buttons below the input.
 */
export class InlineFormWrapper extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['inline-form-wrapper']}>
                {this.props.children}
                {this.props.shouldShowControls ? (
                    <div className={styles['form-controls']}>
                        <CheckmarkButton
                            isDisabled={!this.props.canSubmit}
                            onClick={this.props.onSubmit}
                        />
                        <CancelButton onClick={this.props.onCancel} />
                    </div>
                ) : undefined}
            </div>
        );
    }
}
